import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { Response } from '@angular/http';
import { HttpInterceptor } from "../interceptors/http-interceptor.service";
import { Globals } from "../globals";
import { PermisoService } from "./permiso.service";
import { Caracteristica } from "../interfaces/caracteristica";
import { GeneralService } from "./general.service";

@Injectable()
export class CaracteristicaService {

  constructor(
    private http: HttpInterceptor,
     private globals: Globals,
        private general: GeneralService,
    private permisoService: PermisoService
  ) { }

  getCaracteristicas(
    paginado: any = {
      page: 0,
      pageSize: 10
    },
    orden: any = {
      sort: 'descripcion',
      order: 'asc'
    },
    filtros: any = {
      generico: ''
    }): Observable<any> {
    return this.permisoService.getPermisoAction('CARACTERISTICAS-TIPO-PRODUCTO-VER')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
              paginado: paginado,
              orden: orden,
              filtros: filtros
            }));
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json()
      );
  }

  getTiposCaracteristica(
    paginado: any = {
      page: 0,
      pageSize: 10
    },
    orden: any = {
      sort: 'descripcion',
      order: 'asc'
    },
    filtros: any = {
      generico: ''
    }
  ): Observable<any> {
    return this.permisoService
      .getPermisoAction('TIPOS-CARACTERISTICA-VER')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
              paginado: paginado,
              orden: orden,
              filtros: filtros
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  crearCaracteristica(caracteristica: Caracteristica): Observable<any> {
    return this.permisoService.getPermisoAction('CARACTERISTICA-CREAR')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
              caracteristica: caracteristica
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  editarCaracteristica(caracteristica: Caracteristica): Observable<any> {
    return this.permisoService.getPermisoAction('CARACTERISTICA-EDITAR')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
              caracteristica: caracteristica
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  eliminarCaracteristica(IdCaracteristica: number): Observable<any> {
    return this.permisoService.getPermisoAction('CARACTERISTICA-ELIMINAR')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
              IdCaracteristica: IdCaracteristica
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  ordenCaracteristica(direccion: "subir" | "bajar", IdCaracteristica: number | string): Observable<any> {
    return this.permisoService.getPermisoAction('CARACTERISTICA-ORDEN')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
              direccion: direccion,
              IdCaracteristica: IdCaracteristica
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }
}